export class ModeloProyecto {
    idEmpresaAfiliada?: number = -1;
    idProyecto?: number = -1;
    idUsuarioUM?: number = -1;
    idModelo?: number = -1;
    idProspecto?: number = -1;
    idLanding?: number = -1;
    estatus?: number = -1;
    cantidadGaleria?: number = 0;
    precio?: number = 0;
    precioModelo?: number = 0;
    montoMin?: number = 0;
    montoMax?: number = 99999999.9;
    tipo?: number = 0;
    lotesDisponibles?: number = -1;
    numeroLotes?: number = -1;
    fechaHoraUM?: Date;
    nombre?: string = "";
    terreno?: string = "";
    construccion?: string = "";

}
